export const MOBILE_STATUS_MESSAGES = {
  'timed-out': {
    message: 'Timed out...',
  },
  'getting-media-status': {
    message: 'Getting media status...',
  },
  'welcome-page-visited': {
    message: 'Invitee visited welcome page',
  },
  'media-device': {
    message: 'Local media device connected successfully',
  },
  'media-access-error': {
    message: 'Error accessing media devices',
  },
  'media-access-error-audio': {
    message: 'Error accessing audio device',
  },
  'media-access-error-video': {
    message: 'Error accessing video device',
  },
  'invite-link-sent': {
    message: 'Invite sent successfully',
  },
  'invite-link-error': {
    message: 'Failed to send invite link via SMS',
  },
  'joined-meeting': {
    message: 'Joined meeting successfully',
  },
  'left-meeting': {
    message: 'Left meeting successfully',
  },
  'mobile-test-started': {
    message: 'Mobile test started successfully',
  },
  'mobile-test-completed': {
    message: 'Mobile test completed successfully',
  },
  'mobile-test-failed': {
    message: 'Mobile test failed',
  },
  'test-link-sent': {
    message: 'Test link sent successfully',
  },
  'test-page-visited': {
    message: 'Invitee visited test page',
  },
  'test-link-error': {
    message: 'Failed to send test link via SMS',
  },
} as const;

export type MediaStatusKey = keyof typeof MOBILE_STATUS_MESSAGES;
